import {
  BackendServerActionType,
  BodyModel,
  ButtonElementModel,
  ButtonPanelElementModel,
  ColumnHeaderElementModel,
  DevelopConditionListViewScript,
  DevelopScriptServicePack,
  EditType,
  InputPartsBaseModel,
  LinkElementModel,
  PanelModel,
  PanelType,
  ViewType,
} from '@ktvs8/gocoo-engine-front-end';
import { ApplicationUserUtility } from 'src/app/utility/application-user-utility';

export class MSupplierConditionList implements DevelopConditionListViewScript {
  /**
   * スクリプト名
   */
  scriptName: string = 'MSupplierConditionList';

  /**
   * 初期処理
   * @param panelModels
   * @param service
   */
  init(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {
    this.hiddenRegisterButton(panelModels);
  }

  /**
   * 終了処理
   * @param panelModels
   * @param service
   */
  destroy(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {}

  /**
   * 登録ボタンの表示・非表示を設定する
   * @param panelModels
   */
  hiddenRegisterButton(panelModels: Map<PanelType, PanelModel>) {
    const buttonPanel = panelModels.get(PanelType.FooterButtonPanel) as ButtonPanelElementModel;

    buttonPanel.leftButtons.forEach((button: ButtonElementModel) => {
      if (button.id === 'NewButton') {
        button.isHidden = ApplicationUserUtility.loginUserIsLegal();
      }
    });
  }

  /**
   * ボタン押下処理
   * @param panelModels
   * @param clickedButtonElement
   * @param service
   */
  clickedButton(
    panelModels: Map<PanelType, PanelModel>,
    clickedButtonElement: ButtonElementModel,
    service: DevelopScriptServicePack
  ): void {
    if (clickedButtonElement.id.includes('NewButton')) {
      service.moveViewService.moveViewInGocooEngine(ViewType.Edit, 'MSupplier', EditType.New, {});
      //Edit画面を開く処理
    }
  }

  /**
   * リンク押下処理
   * @param panelModels
   * @param clickedLinkElement
   * @param service
   */
  clickedLink(
    panelModels: Map<PanelType, PanelModel>,
    clickedLinkElement: LinkElementModel,
    service: DevelopScriptServicePack
  ): void {}

  /**
   * 入力イベント処理
   * @param inputPartsModel
   * @param panelModels
   * @param service
   */
  inputPartsEvent(
    inputPartsModel: InputPartsBaseModel,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): void {}

  /**
   * データ取得後の処理
   * @param bodyModel
   * @param headers
   */
  fetchedList(bodyModel: BodyModel, headers: ColumnHeaderElementModel[]): void {
    bodyModel.rows.forEach((row) => {
      row.cells
        .filter((cell) => cell.columnName === 'StatusName')
        .forEach((cell) => {
          if (cell.cellModel.value === '認証済') {
            cell.cellModel.class.push('verified');
          } else if (cell.cellModel.value === '認証待ち') {
            cell.cellModel.class.push('waiting');
          }
        });
    });
  }

  /**
   * バリデーションチェック
   * @param targetValidationPanel
   * @param actionType
   * @param panelModels
   * @param service
   */
  validationCheck(
    targetValidationPanel: PanelType,
    actionType: BackendServerActionType,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): boolean {
    return true;
  }
}
